import axios from "axios";

export const proceedToPayment = async (reference,merchantRef) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_HELLOPAY_BASE_URL}v1/merchants/${merchantRef}/payment-links/${reference}/payment-urls`, {}, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
};